
(function (module) {
    "use strict";

    module.component('productForecast', {
        template: require('./productForecastComponent.html'),
        bindings: {
            parameters: '<',
            stepEnter: "=",
            market: "<",
            brands: "=",
            isEditable: "<",
            wizardStepIndex: '=',
            showInMilions: '<'
        },
        controller: ['$scope', 'forecastCacheService', function(this: $TSFixMe, $scope: $TSFixMe, forecastCacheService: $TSFixMe) {
            var $ctrl = this;
            $ctrl.forecastCacheService = forecastCacheService;
        }]
    })

})(angular.module('topline.modules'));